import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

export interface PositionNameDialogData {
  title: string;
  positionName?: string;
}

@Component({
  selector: 'app-position-name-dialog',
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatFormFieldModule,
    MatInputModule
  ],
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content class="pt-4">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline" class="w-full mt-2">
          <mat-label>設置場所</mat-label>
          <input matInput formControlName="positionName" placeholder="例: 入口付近">
        </mat-form-field>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="pb-4 pr-4">
      <button matButton type="button" (click)="onCancel()">キャンセル</button>
      <button matButton="tonal" color="primary" type="button" (click)="onSubmit()">保存</button>
    </mat-dialog-actions>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PositionNameDialogComponent {
  private readonly fb = inject(NonNullableFormBuilder);
  private readonly dialogRef = inject(MatDialogRef<PositionNameDialogComponent, string | undefined>);
  readonly data = inject<PositionNameDialogData>(MAT_DIALOG_DATA);

  readonly form = this.fb.group({
    positionName: [this.data.positionName ?? '']
  });

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.dialogRef.close(this.form.controls.positionName.value.trim());
  }
}
